<template>
  <!-- wrapper(s) -->
  <div class="wrapper">
    <Header class="header" :val="headerTitle"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <section v-for="(value, key) in rentalList" :key="key">
          <section class="hr pt15 mb15">
            <div class="prdState">
              <div>
                <span class="inB bold pointC4">
                  <i>{{ value.orderInfo.orderDate | dateFormatter('.') }}</i>
                </span>
                <span class="inB">
                  (주문번호 :
                  <i>{{ value.orderId }}</i>
                  )
                </span>
              </div>
            </div>
          </section>

          <section class="hr">
            <div class="prdList">
              <div class="prdItem xs" @click="goDetail(value.orderInfo.productIndex, value.orderInfo.discntFlag)">
                <div class="imgArea">
                  <span class="img">
                    <img
                      :src="value.orderInfo.thumbnail ? value.orderInfo.thumbnail : '/img/error_image.jpg'"
                      :alt="value.orderInfo.productName"
                      onerror="this.src='/img/error_image.jpg';"
                    />
                  </span>
                </div>
                <div class="infoArea">
                  <div class="tit row2">
                    <span>{{ value.orderInfo.productName }}</span>
                  </div>
                  <div class="txtItem">
                    <span>{{ value.orderInfo.model }}</span>
                  </div>
                  <div class="price">
                    <span class="money">
                      월 렌탈료
                      <em>{{ value.orderInfo.rentalAmount | currency }}</em>
                      원x{{ value.orderInfo.rentalPeriod }}개월
                    </span>
                  </div>
                </div>
              </div>
              <div class="selectedOpt">
                <div class="txtOpt">
                  <div class="opt" v-if="value.productOption != ''">
                    <span class="item">옵션</span>
                    <span class="val">{{ value.productOption }}</span>
                  </div>
                  <div class="opt" v-if="value.rentalDuration != ''">
                    <span class="item">렌탈기간</span>
                    <span class="val">{{ value.rentalDuration }}</span>
                  </div>
                  <div class="opt" v-if="value.releaseDate != ''">
                    <span class="item">설치일</span>
                    <span class="val">{{ value.releaseDate }}</span>
                  </div>
                </div>
              </div>
              <div class="btnArea nowrap">
                <button type="button" class="btn_s s" @click="showContract(value.orderId)">계약서</button>
                <button type="button" class="btn_s s" @click="goVoucher(value.orderId)">증빙서류</button>
                <button type="button" class="btn_s s" @click="goPaymentHistory(value.orderId)">수납현황</button>
              </div>
            </div>
          </section>

          <section class="hr">
            <div class="titArea">
              <h2 class="titH4">배송지 정보</h2>
            </div>
            <table class="tableY noLine bbNone">
              <colgroup>
                <col style="width: 110px" />
                <col style="width: auto" />
              </colgroup>
              <tbody>
                <tr>
                  <td class="th">이름</td>
                  <td>{{ value.deliveryInfo.customerName }}</td>
                </tr>
                <tr>
                  <td class="th">핸드폰번호</td>
                  <td>{{ value.deliveryInfo.mobile | phoneFormatter }}</td>
                </tr>
                <tr>
                  <td class="th">주소</td>
                  <td>
                    {{ value.deliveryInfo.post }}
                    <br />
                    {{ value.deliveryInfo.address }}
                    <br />
                    {{ value.deliveryInfo.addressDetail }}
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- table (e) -->
          </section>

          <section class="hr">
            <div class="titArea">
              <h2 class="titH4">결제 정보</h2>
              <button
                type="button"
                class="btn_s round s"
                v-if="value.ordrDivCd != 'RORT00IS'"
                @click="$router.push({ name: 'myPaymentInfo', params: { oderId: value.orderId } })"
              >
                변경
              </button>
            </div>
            <table class="tableY noLine bbNone">
              <colgroup>
                <col style="width: 110px" />
                <col style="width: auto" />
              </colgroup>
              <tbody>
                <tr>
                  <td class="th">결제 수단</td>
                  <td v-if="value.payInfo.payMethod == '신용카드'">{{ value.payInfo.cardName }}&nbsp;&nbsp;{{ value.payInfo.cardNumber }}</td>
                  <td v-else>{{ value.payInfo.bankName }} {{ value.payInfo.accountNumber }}</td>
                </tr>
                <tr>
                  <td class="th">결제일</td>
                  <td>매월 {{ value.payInfo.payDate }}</td>
                </tr>
              </tbody>
            </table>
            <!-- table (e) -->
          </section>
        </section>
        <section class="hr" v-show="rentalList.length < 1">
          <div class="resultMsg txtOnly">
            <p class="copy">이용중인 렌탈 내역이 없습니다.</p>
          </div>
        </section>
        <CommonBanner></CommonBanner>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>
    <OrderContractInfo v-if="contract" @close="contract = false" :propsProductObj="productObj"></OrderContractInfo>
  </div>
  <!-- wrapper(e) -->
</template>

<script>
import ApiService from '@/common/api.service';
import CommonBanner from '@/components/banner/CommonBanner';
import OrderContractInfo from '@/components/comm/OrderContractInfo';
export default {
  name: 'myUsedRental',
  components: { CommonBanner, OrderContractInfo },
  mounted() {
    this.myRentalInit();
  },
  data: function () {
    return {
      headerTitle: '이용중인 렌탈',
      contract: false,
      productObj: {},
      rentalList: [],
    };
  },
  watch: {},
  computed: {},
  methods: {
    myRentalInit: function () {
      ApiService.service('GET', '/order/auth/rentalList')
        .then(({ data }) => {
          console.log(data);
          this.rentalList = data.result;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    goDetail: function (idx, discntFlag) {
      if (idx != '0' && discntFlag == 'N') {
        this.$router.push('/product/category/detail/' + idx);
      }
    },
    goVoucher: function (oi) {
      this.$router.push({
        name: 'myVoucher',
        params: { orderId: oi },
      });
    },
    goPaymentHistory: function (oi) {
      this.$router.push({
        name: 'paymentHistory',
        params: { orderId: oi },
      });
    },
    showContract(target) {
      // 렌탈계약서
      this.productObj = {
        orderId: target,
      };

      this.contract = true;
    },
  },
  destroyed() {},
};
</script>
